<script lang="ts" setup>
import type { CountMatch } from "@/queries/saved-calls";

// Purely presentational — driven by the saved-call list payload (which already carries the active
// baseline summary). Deliberately NOT a query hook: this renders inside a DataView table cell, which
// DataTables mounts outside the app's inject context, so a useQuery() here can't reach the query
// client. Reading from props keeps it context-free and avoids an N+1 fetch per row.
defineProps<{ hasBaseline: boolean; countPolicy: CountMatch | null }>();
</script>

<template>
  <span
    v-if="hasBaseline"
    class="badge bg-success"
    :title="`Runs of this call are validated against a baseline (count policy: ${countPolicy})`"
  >
    <i class="bi bi-clipboard-check me-1"></i>Baseline: {{ countPolicy }}
  </span>
  <span v-else class="text-muted small" title="No baseline set — regression just smoke-runs this call">
    No baseline
  </span>
</template>
